import { jsx as _jsx } from "react/jsx-runtime";
const stateToColour = {
    UNKNOWN: 'red',
    COMMISSIONED: 'lightblue',
    DECOMMISSONED: 'red',
    SUSPENDED: 'red',
    CALIBRATED: 'red',
    TRANSITIN: 'red',
    TRANSITOUT: 'red',
    WITHCUSTOMER: 'red',
    WITHENGINEER: 'red',
    INVENTORY: 'red',
    ORDEREDCUSTOMER: 'red',
    ORDERED: 'red',
    RETIRED: 'red',
    MANUFACTURING: 'white',
    JOINED: 'red',
};
export const deviceState = (p) => {
    let state = p.value;
    let colour;
    if (state) {
        colour = stateToColour[state] ?? 'white';
        state = state.substring(0, 1);
    }
    return _jsx("div", { style: { backgroundColor: colour, width: '100%', padding: '0px' }, children: state });
};
export const espState = (p) => {
    const state = p.value;
    let colour;
    if (state < -100) {
        colour = 'red';
    }
    else {
        colour = 'green';
    }
    return _jsx("div", { style: { backgroundColor: colour, width: '100%', padding: '0px' }, children: Math.round(state * 10) / 10 });
};
export const sfState = (p) => {
    const state = p.value;
    let colour;
    if (state < -7 || state > 12) {
        colour = 'red';
    }
    else {
        colour = 'green';
    }
    return _jsx("div", { style: { backgroundColor: colour, width: '100%', padding: '0px' }, children: state });
};
export const rssiState = (p) => {
    const state = p.value;
    let colour;
    if (state < -120) {
        colour = 'red';
    }
    else {
        colour = 'green';
    }
    return _jsx("div", { style: { backgroundColor: colour, width: '100%', padding: '0px' }, children: state });
};
export const snrState = (p) => {
    const state = p.value;
    let colour;
    if (state > 5) {
        colour = 'green';
    }
    else if (state < -15) {
        colour = 'darkred';
    }
    else if (state < -5) {
        colour = 'red';
    }
    else if (state <= 5) {
        colour = 'orange';
    }
    return _jsx("div", { style: { backgroundColor: colour, width: '100%', padding: '0px' }, children: state });
};
